import React from 'react'
import { InfoArea } from './style'

export default ({ children, isHorizontal = false, background }) => (
  <InfoArea isHorizontal={isHorizontal} background={background}>
    {children}
  </InfoArea>
)
